<template>
  <div class="wrapper">
    <div class="title">
      <img :src="require('@/assets/home/report_sample.jpg')" alt="证书报告样本">
    </div>
    <div class="content">
      <el-carousel :autoplay="false" :interval="4000" type="card" height="384px" indicator-position="none"
                   ref="carousel">
        <custom-swiper-item v-for="(v,i) in list" :key="i">
          <el-image :src="v.image"></el-image>
        </custom-swiper-item>
      </el-carousel>
      <div class="btn-group">
        <div class="prev" @click="$refs.carousel.prev()">
          <i class="el-icon-arrow-left"></i>
        </div>
        <div class="next" @click="$refs.carousel.next()">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomSwiperItem from '@/components/CustomSwiperItem'

export default {
  components: {
    CustomSwiperItem
  },
  name: "ReportSample",
  data() {
    return {
      list: []
    }
  },
  created() {
    this.$request.get('/Home/reportSample')
        .then(res => {
          if (res.code === 0) {
            this.list = res.data
          }
        })
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .title {
    color: #2D2D2D;
    font-size: 38px;
    font-weight: bold;
    //border-bottom: 1px solid #D7D7D7;
    //padding-bottom: 15px;
    width: 100%;
    text-align: center;
  }

  .content {
    margin-top: 35px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .btn-group {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 35px;

      .prev {
        margin-right: 30px;
      }

      .next {
        margin-left: 30px;
      }

      .prev, .next {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        background-color: #F1F5FF;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        i {
          font-size: 26px;
          color: #6C6C6C;
        }
      }
    }

    ::v-deep {
      .el-carousel {
        width: 100%;
        margin-left: 58px;

        .el-carousel__arrow {
          display: none;
        }
      }
    }
  }
}
</style>